function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './SelectFieldCustom.css';
import React, { useState, useRef, useEffect } from 'react';
import Select, { components } from 'react-select';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import { rtlStyles, ltrStyles, commonStyles } from '../accountAuthorizationStyles';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
export const reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
let globalOpenDropdown = null;
const dropdownInstances = new Set();
const SelectFieldCustom = _ref => {
  let {
    name,
    value,
    changeEvent,
    blurEvent,
    label,
    id,
    options,
    labelLight,
    fieldError,
    autoComplete = 'off',
    required = false,
    placeholder
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [highLightDrop, setHighLightDrop] = useState(false);
  const clickedDropRef = useRef(false);
  const [dropOpened, setDropOpened] = useState(false);
  const [selected, setSelected] = useState(null);
  const instanceId = useRef(id || Math.random().toString(36));
  const closeThisDropdown = useRef(() => {
    setDropOpened(false);
    setHighLightDrop(false);
    if (globalOpenDropdown === instanceId.current) {
      globalOpenDropdown = null;
    }
  });
  useEffect(() => {
    dropdownInstances.add(closeThisDropdown.current);
    const handleGlobalClick = e => {
      const target = e.target;
      if (!target.closest('.dropdown-primary')) {
        // close all dropdowns when clicking outside
        dropdownInstances.forEach(closeDropdown => closeDropdown());
        globalOpenDropdown = null;
      }
    };
    const handleGlobalTouch = e => {
      const target = e.target;
      if (!target.closest('.dropdown-primary')) {
        // close all dropdowns when touching outside
        dropdownInstances.forEach(closeDropdown => closeDropdown());
        globalOpenDropdown = null;
      }
    };
    document.addEventListener('click', handleGlobalClick);
    document.addEventListener('touchstart', handleGlobalTouch);
    return () => {
      dropdownInstances.delete(closeThisDropdown.current);
      document.removeEventListener('click', handleGlobalClick);
      document.removeEventListener('touchstart', handleGlobalTouch);
    };
  }, []);
  useEffect(() => {
    if (value && value !== '-1' && options && options.length !== 0) {
      const chosenItem = options.filter(el => el.value === value);
      setSelected(chosenItem);
    }
  }, [value]);
  function handleChange(el) {
    changeEvent(el.value);
    setSelected(el);
    setDropOpened(false);
  }
  function handleBlur(el) {
    clickedDropRef.current = false;
    setHighLightDrop(false);
    blurEvent(el.value);
    setDropOpened(false);
  }
  function handleDropMousedown() {
    clickedDropRef.current = true;

    // Close other dropdowns first
    if (globalOpenDropdown && globalOpenDropdown !== instanceId.current) {
      dropdownInstances.forEach(closeDropdown => closeDropdown());
    }
    const newState = !dropOpened;
    setDropOpened(newState);
    globalOpenDropdown = newState ? instanceId.current : null;
    setDropOpened(!dropOpened);
  }
  function handleDropFocus() {
    if (!clickedDropRef.current) {
      setHighLightDrop(true);
    }
  }
  const handleDropKeyDown = e => {
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  const handleDropTouchstart = e => {
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      e.preventDefault(); // Prevent double firing with mouse events

      // Close other dropdowns first
      if (globalOpenDropdown && globalOpenDropdown !== instanceId.current) {
        dropdownInstances.forEach(closeDropdown => closeDropdown());
      }
      const newState = !dropOpened;
      setDropOpened(newState);
      globalOpenDropdown = newState ? instanceId.current : null;
    }
  };
  const DropdownIndicator = props => /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-select-icon",
    width: "9",
    height: "5.179",
    viewBox: "0 0 9 5.179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbols",
    transform: "translate(9.5 -0.821) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron-right",
    "data-name": "ic/chevron-right",
    transform: "translate(-7 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_chevron-right-2",
    "data-name": "ic_chevron-right",
    d: "M14.5,8.394h0L10,13,5.5,8.394a1.9,1.9,0,0,1,2.692-.031l.031.031L10,10.212h0l1.776-1.818a1.9,1.9,0,0,1,2.692-.031Z",
    transform: "translate(0 20) rotate(-90)",
    fill: "currentColor"
  })))));
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group lr__form-group-select"
  }, label ? /*#__PURE__*/React.createElement("label", {
    className: `form-label ${labelLight ? 'lr__label-light' : ''}
             ${highLightDrop ? 'form-label--active' : ''}
          ${value && value !== '-1' ? 'form-label--active' : ''}
          `,
    htmlFor: id
  }, label, required ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : '') : null, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-primary lr__dd",
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: name,
    id: id,
    options: options,
    value: selected,
    className: `react-custom-select
            ${highLightDrop ? 'react-custom-select--outlined' : ''}
              ${value ? 'form-input--filled' : ''}
            ${fieldError && fieldError.length ? 'form-input--error' : ''}
						${fieldError ? 'react-custom-select--error' : ''}`,
    onFocus: handleDropFocus,
    onMouseDown: handleDropMousedown,
    onChange: el => handleChange(el),
    onKeyDown: handleDropKeyDown,
    onBlur: el => handleBlur(el),
    placeholder: '',
    "aria-label": label,
    "aria-labelledby": label,
    menuIsOpen: dropOpened,
    components: {
      DropdownIndicator
    }
  })))), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null);
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `
    ${rtl ? rtlStyles : ltrStyles} ${commonStyles}
    ${rtl ? rtlStylesCustomSelect : ltrStylesCustomSelect} ${commonStylesCustomSelect}`
  }, children);
};
const commonStylesCustomSelect = "cgx3xg1";
const ltrStylesCustomSelect = "l1s0eb49";
const rtlStylesCustomSelect = "r33729j";
export default SelectFieldCustom;